import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button,
  TextField,
  Select, MenuItem, InputLabel, FormControl, CircularProgress
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Stack from '@mui/material/Stack';
import { useParams } from 'react-router-dom';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { GetApp as DownloadIcon, InsertDriveFile as CsvIcon, Description as ExcelIcon } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
// import CircularProgress from '@mui/material/CircularProgress';




function ProdReport(props) {
  const { endpoint } = useParams();
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [showGrid, setShowGrid] = useState(true);
  const [itemCode, setItemCode] = useState('');
  const [ledgerCode, setLedgerCode] = useState('');
  const [subledgerCode, setSubLedgerCode] = useState('');
  const [serialNumber, setSerialNumber] = useState(1);
  const [Hours, setHours] = useState(0);
  const [FurnaceTonnage, setFurnaceTonnage] = useState(0);
  const [grade, setGrade] = useState('');

  const [reportData, setReportData] = useState([]);
  const [reportData1, setReportData1] = useState([]);

  const [itemMasterEntries, setItemMasterEntries] = useState([]);
  const [subledgerMaster, setSubledgerMaster] = useState([]);
  const [ledgerEntries, setLedgerEntries] = useState([]);
  const [VehicleMasterEntries, setVehicleMasterEntries] = useState([]);
  const [NatureMasterEntries, setNatureMasterEntries] = useState([]);
  const [RejectionMasterEntries, setRejectionMasterEntries] = useState([]);
  const [ProcessMasterEntries, setProcessMasterEntries] = useState([]);
  const [compMasterEntries, setCompMasterEntries] = useState([]);
  const [showH1Component, setShowH1Component] = useState(false);

  const [exportFormat, setExportFormat] = useState(null);
  const [selectLedger, setSelectLedger] = useState(true);
  const [selectSubledger, setSelectSubledger] = useState(false);
  const [selectItem, setSelectItem] = useState(false);
  const [selectFurnaceTonnage, setSelectFurnaceTonnage] = useState(false);
  const [selectHours, setSelectHours] = useState(false);
  const [selectGrade, setSelectGrade] = useState(false);


  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const flag = new URLSearchParams(location.search).get('flag');

  useEffect(() => {
    setReportData([]);
    if (endpoint) {
      setSelectSubledger(true);
      setSelectItem(true);
      setSelectFurnaceTonnage(false);
      setSelectHours(false);
      setSelectGrade(false);

      if (endpoint === 'ProductionRegisterHeatTypewise') {
        setSelectFurnaceTonnage(true);
        setSelectGrade(false);
      } else if (endpoint === 'ProductionRegisterHourwise') {
        setSelectHours(true);
        setSelectGrade(false);
      } else if (endpoint === 'ProductionRegisterItemwise') {
        setSelectSubledger(false);
        setSelectItem(false);
        setSelectGrade(true);
      }
    }
  }, [endpoint]);


  useEffect(() => {
    setSerialNumber(1);
  }, [endpoint]);


  useEffect(() => {
    if (showH1Component === true) {
      generatePDF();
      setTimeout(() => {
        setShowH1Component(false);
      }, 1000);
    }
  }, [showH1Component]);

  const incrementSerialNumber = () => {
    setSerialNumber(1);
  };

  useEffect(() => {
    incrementSerialNumber();
  }, []);

  useEffect(() => {
    fetchSubLedgerMaster();
    fetchItemMaster();
    fetchNatureMaster();
    fetchVehicleMaster();
    fetchRejectionMaster();
    fetchProcessMaster();
    fetchCompMaster();
  }, []);

  const fetchReportData = async (requestData) => {
    try {
      setLoading(true);
      const response = await axios.get(`https://www.wingap.net.in/api/${endpoint}`, { params: requestData });
      setReportData(response.data);
      //console.log("Report Data : ", response.data);
    } catch (error) {
      console.log('error:', error);
    } finally {
      setLoading(false);
      incrementSerialNumber(); // Call incrementSerialNumber after setting report data
    }
  };

  const fetchReportData1 = async (requestData) => {
    try {
      setLoading(true);
      //console.log("endpoint :-", endpoint);

      const response = await axios.get(`https://www.wingap.net.in/api/${endpoint}`, { params: requestData });
      setReportData1(response.data);
      //console.log("Report Data 1: ", response.data);
    } catch (error) {
      console.log('error:', error);
    } finally {
      setLoading(false);
      incrementSerialNumber();
    }
  };

  const handleSubLedgerChange = (e) => {
    setSubLedgerCode(e.target.value);
  };

  const handleItemChange = (e) => {
    setItemCode(e.target.value);
  };

  const handleReset = () => {
    setSubLedgerCode('');
    setItemCode('');
    setHours(0);
    setFurnaceTonnage(0);
    setGrade('');
  };

  const fetchCompMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/company');
      setCompMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchSubLedgerMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/subledgerMaster');
      setSubledgerMaster(response.data);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };


  const fetchItemMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/items-master');
      setItemMasterEntries(response.data);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchNatureMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/Nature');
      setNatureMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchVehicleMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/vehicle');
      setVehicleMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchProcessMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/process');
      setProcessMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const fetchRejectionMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/rejection');
      setRejectionMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  const handleSetParams = () => {
    const startDateFormatted = new Date(startDate).toISOString();
    const endDateFormatted = new Date(endDate).toISOString();

    const requestData = {
      USERID: props.name,
      DeptCode: props.selectedDept,
      YearCode: props.selectedYear,
      CompCode: props.selectedCompany,
      startDate: startDateFormatted,
      endDate: endDateFormatted,
      flag: flag ? `${flag}` : '',
    };
    if (selectGrade && grade) {
      requestData.grade = grade;
    }

    if (selectHours && Hours) {
      requestData.Hours = parseInt(Hours);
    }

    if (selectFurnaceTonnage && FurnaceTonnage) {
      requestData.FurnaceTonnage = parseInt(FurnaceTonnage);
    }

    if (selectSubledger && subledgerCode) {
      requestData.subledgerCode = parseInt(subledgerCode);
    }

    if (selectItem && itemCode) {
      requestData.itemCode = parseInt(itemCode);
    }

    if (selectSubledger && selectItem && subledgerCode && itemCode) {
      if (selectSubledger && subledgerCode) {
        requestData.subledgerCode = parseInt(subledgerCode);
      }
      requestData.itemCode = parseInt(itemCode);
    }
    fetchReportData(requestData);
    // console.log("Param Data", requestData);
  };

  const getCompanyName = (compCode) => {
    const company = compMasterEntries.find((entry) => entry.CompCode === compCode);
    return company ? company.CompName : '';
  };

  // Function to get SubAcHead based on SubAccode
  const getSubAcHead = (subAccode) => {
    const subledger = subledgerMaster.find((entry) => entry.SubAcCode == subAccode);
    return subledger ? subledger.SubAcHeadEng : '';
  };

  const getMonthName = (monthNo) => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    if (monthNo >= 1 && monthNo <= 12) {
      return months[monthNo - 1];
    } else {
      return ''; // Return empty string for invalid month numbers
    }
  };


  // Function to get ItName and PartNo based on ItCode
  const getItInfo = (itCode) => {
    const item = itemMasterEntries.find((entry) => entry.ItCode === itCode);
    return item ? { ItName: item.ItName, PartNo: item.PartNo } : { ItName: '', PartNo: '' };
  };

  const getItName = (itCode) => {
    const item = itemMasterEntries.find((entry) => entry.ItCode === itCode);
    return item ? item.ItName : '';
  };

  const getNatureName = (natureCode) => {
    const nature = NatureMasterEntries.find((entry) => entry.NatureCode == natureCode);
    return nature ? nature.NatureName : '';
  };

  const getVehicleName = (vehicleCode) => {
    const vehicle = VehicleMasterEntries.find((entry) => entry.VehicleCode == vehicleCode);
    return vehicle ? vehicle.VehicleNo : '';
  };

  const getRejName = (rejcode) => {
    const rejection = RejectionMasterEntries.find((entry) => entry.RejCode == rejcode);
    return rejection ? rejection.RejName : '';
  };

  const getProcessName = (processcode) => {
    const process = ProcessMasterEntries.find((entry) => entry.ProcessCode == processcode);
    return process ? process.ProcessName : '';
  };

  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const csvContent = (data, headers, companyName, dateRange) => {
    const additionalInfo = [
      ['Company Name:', companyName],
      ['Date Range:', dateRange],
      [],
    ];
    const content = additionalInfo.concat([headers.join(',')]);

    data.forEach(rowData => {
      const rowValues = headers.map(header => {
        if (keyIncludesDate(header)) {
          return new Intl.DateTimeFormat('en-GB').format(new Date(rowData[header]));
        } else if (header === 'SubAccode' || header === 'subaccode') {
          return getSubAcHead(rowData[header]);
        } else if (header === 'ItCode' || header === 'itcode' || header === 'Itcode') {
          const { ItName, PartNo } = getItInfo(rowData[header]);
          return `${ItName} - ${PartNo}`;
        } else if (header === 'RejCode') {
          return getRejName(rowData[header]);
        } else if (header === 'ProcessCode') {
          return getProcessName(rowData[header]);
        } else if (header === 'NatureCode') {
          return getNatureName(rowData[header]);
        } else if (header === 'VehicleCode') {
          return getVehicleName(rowData[header]);
        } else {
          return rowData[header];
        }
      });

      content.push(rowValues.join(','));
    });

    return content.join('\n');
  };

  const excelContent = (data, headers, companyName, dateRange) => {
    const additionalInfo = [
      ['Company Name:', companyName],
      ['Date Range:', dateRange],
      [],
    ];

    const transformedHeaders = headers.map(header => getCustomFieldName(header));
    const content = additionalInfo.concat([transformedHeaders.join(',')]);

    data.forEach(rowData => {
      const rowValues = headers.map(header => {
        if (keyIncludesDate(header)) {
          return new Intl.DateTimeFormat('en-GB').format(new Date(rowData[header]));
        } else if (header === 'SubAccode' || header === 'subaccode') {
          return getSubAcHead(rowData[header]);
        } else if (header === 'ItCode' || header === 'itcode' || header === 'Itcode') {
          const { ItName, PartNo } = getItInfo(rowData[header]);
          return `${ItName} - ${PartNo}`;
        } else if (header === 'RejCode') {
          return getRejName(rowData[header]);
        } else if (header === 'ProcessCode') {
          return getProcessName(rowData[header]);
        } else if (header === 'NatureCode') {
          return getNatureName(rowData[header]);
        } else if (header === 'VehicleCode') {
          return getVehicleName(rowData[header]);
        } else {
          return rowData[header];
        }
      });
      content.push(rowValues.join(','));
    });

    return content.join('\n');
  };

  const handleExport = async (format) => {
    setExportFormat(format);

    if (format === 'pdf') {
      generatePDF();
    } else if (format === 'csv') {
      const dataToExport = endpoint === 'PartyStockLedger' ? reportData1 : reportData;

      if (!dataToExport || dataToExport.length === 0) {
        console.error('No data available for export');
        return;
      }

      const csvContentData = csvContent(dataToExport, endpointFields[endpoint], getCompanyName(props.selectedCompany), `${startDate} to ${endDate}`);

      const blob = new Blob([csvContentData], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, 'Report_Data.csv');
    } else if (format === 'excel') {
      const dataToExport = endpoint === 'PartyStockLedger' ? reportData1 : reportData;

      if (!dataToExport || dataToExport.length === 0) {
        console.error('No data available for export');
        return;
      }

      const excelContentData = excelContent(dataToExport, endpointFields[endpoint], getCompanyName(props.selectedCompany), `${startDate} to ${endDate}`);

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('Report Data');

      const rows = excelContentData.split('\n');
      rows.forEach(row => {
        sheet.addRow(row.split(','));
      });

      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Report_Data.xlsx');
      });
    }

  };

  function keyIncludesDate(key) {
    return key.toLowerCase().includes('date');
  }

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: `${endpoint}`,
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  const calculateColumnSum = (fieldName, endpoint) => {
    const data = endpoint === 'PartyStockLedger' ? reportData1 : reportData;
    //console.log("endpoint :", endpoint, data);
    if (excludeFromSum(fieldName)) {
      return '';
    }

    if (fieldName === 'StockBal') {
      const stockBalSum = data.reduce((accumulator, rowData) => {
        const balQty = Math.abs(isNaN(rowData['BalQty']) ? 0 : parseFloat(rowData['BalQty']));
        const sentQty = Math.abs(isNaN(rowData['SentQty']) ? 0 : parseFloat(rowData['SentQty']));
        const recdQty = Math.abs(isNaN(rowData['RecdQty']) ? 0 : parseFloat(rowData['RecdQty']));
        const stockBal = balQty + sentQty - recdQty;
        return accumulator + stockBal;
      }, 0);
      return stockBalSum.toFixed(2);
    }
    else if (fieldName === 'Cl.Qty') {
      const clQtySum = data.reduce((accumulator, rowData) => {
        const opQty = Math.abs(isNaN(rowData['OpQty']) ? 0 : parseFloat(rowData['OpQty']));
        const prodQty = Math.abs(isNaN(rowData['ProdQty']) ? 0 : parseFloat(rowData['ProdQty']));
        const salesQty = Math.abs(isNaN(rowData['SalesQty']) ? 0 : parseFloat(rowData['SalesQty']));
        const rejQty = Math.abs(isNaN(rowData['TotREJ']) ? 0 : parseFloat(rowData['TotREJ']));
        const clQty = opQty + prodQty - salesQty - rejQty;
        return accumulator + clQty;
      }, 0);
      return clQtySum.toFixed(2);
    }
    else if (fieldName === 'Amount') {
      const amtSum = data.reduce((accumulator, rowData) => {
        const qty = Math.abs(isNaN(rowData['Qty']) ? 0 : parseFloat(rowData['Qty']));
        const rate = Math.abs(isNaN(rowData['Rate']) ? 0 : parseFloat(rowData['Rate']));
        const clQty = qty * rate;
        return accumulator + clQty;
      }, 0);
      return amtSum.toFixed(2);
    }
    else if (fieldName === 'InHouse_Cast') {
      const castSum = data.reduce((accumulator, rowData) => {
        const opqty = Math.abs(isNaN(rowData['OpQty']) ? 0 : parseFloat(rowData['OpQty']));
        const prodqty = Math.abs(isNaN(rowData['ProdQty']) ? 0 : parseFloat(rowData['ProdQty']));
        const sentqty = Math.abs(isNaN(rowData['SentQty']) ? 0 : parseFloat(rowData['SentQty']));
        const rejqty = Math.abs(isNaN(rowData['TotREJ']) ? 0 : parseFloat(rowData['TotREJ']));

        const clQty = opqty + prodqty - sentqty - rejqty;
        return accumulator + clQty;
      }, 0);
      return castSum.toFixed(2);
    }
    else if (fieldName === 'InHouse_M/c') {
      const mcqty = data.reduce((accumulator, rowData) => {
        const recdQty = Math.abs(isNaN(rowData['RecdQty']) ? 0 : parseFloat(rowData['RecdQty']));
        const salesQty = Math.abs(isNaN(rowData['SalesQty']) ? 0 : parseFloat(rowData['SalesQty']));

        const clQty = recdQty - salesQty;
        return accumulator + Math.max(0, clQty);
      }, 0);
      return mcqty.toFixed(2);
    }
    else if (fieldName === 'At_m/cshop') {
      const shopqty = data.reduce((accumulator, rowData) => {
        const recdQty = Math.abs(isNaN(rowData['RecdQty']) ? 0 : parseFloat(rowData['RecdQty']));
        const sentQty = Math.abs(isNaN(rowData['SentQty']) ? 0 : parseFloat(rowData['SentQty']));

        const clQty = sentQty - recdQty;
        return accumulator + clQty;
      }, 0);
      return shopqty.toFixed(2);
    }
    else {
      const sum = data.reduce((accumulator, rowData) => {
        return accumulator + (isNaN(rowData[fieldName]) ? 0 : Math.abs(parseFloat(rowData[fieldName])));
      }, 0);
      return sum.toFixed(2);
    }
  };


  // Function to check if a column should be excluded from sum
  const excludeFromSum = (fieldName) => {
    const excludedColumns = ['furnacetonnage', 'entryno', 'flag', 'trdate',
      'subachead', 'itcode', 'empcode', 'empname', 'remark1', 'ciheats', 'diheats',
      'CIRate', 'DIRate', 'itname', 'Hours', 'MonthNo'];
    const lowerCaseFieldName = fieldName.toLowerCase();
    return excludedColumns.some(excludedColumn => excludedColumn.toLowerCase() === lowerCaseFieldName);
  }

  const generateCalculationRow = (flagData) => {
    return (
      <tr style={{ backgroundColor: '#f2f2f2', color: 'black', fontWeight: 'bold' }}>
        <td></td>
        {endpointFields[endpoint].map((field) => (
          <td
            key={field}
            style={{
              padding: '5px',
              background: '#f2f2f2',
              border: '1px solid #333', textAlign: 'right'
            }}
          >
            {field.toLowerCase().includes('date') ? '' : calculateColumnSumByEntryNo(field, flagData)}
          </td>
        ))}
      </tr>
    );
  };

  const calculateColumnSumByEntryNo = (fieldName, flagData) => {
    const data = reportData;
    if (excludeFromSum(fieldName)) {
      return '';
    }
    if (fieldName === 'Amount') {
      const amount = data.reduce((accumulator, rowData) => {
        const cirate = Math.abs(isNaN(rowData['CIRate']) ? 0 : parseFloat(rowData['CIRate']));
        const dirate = Math.abs(isNaN(rowData['DIRate']) ? 0 : parseFloat(rowData['DIRate']));
        const prodweight = Math.abs(isNaN(rowData['ProdWeight']) ? 0 : parseFloat(rowData['ProdWeight']));

        const itcode = rowData['itcode'];
        const item = itemMasterEntries.find(group => group.ItCode === itcode);
        const rate = item ? item.GradeCode : 0; // Default to 0 if item not found

        let stockBal = 0;
        if (rate === '1') {
          stockBal = cirate * prodweight;
        } else if (rate === '2') {
          stockBal = dirate * prodweight;
        }

        return accumulator + stockBal;
      }, 0);

      return amount.toFixed(2);
    }
    const sum = flagData.reduce((accumulator, rowData) => {
      return accumulator + (isNaN(rowData[fieldName]) ? 0 : Math.abs(parseFloat(rowData[fieldName])));
    }, 0);
    return sum.toFixed(2);
  };

  const endpointFields = {
    ProductionRegisterMonthwise: ['itcode', 'MonthNo', 'Qty-Weight',],
    ProductionRegisterItemwise: ['itname', 'prodnweight', 'ActualWeightPer', 'ProdQty', 'ProdWeight', 'CIRate', 'DIRate', 'Amount'],
    ProductionRegisterHourwise: ['Hours', 'entryno', 'flag', 'trdate', 'subachead', 'itcode', 'ActualQty', 'ActualWeight', 'empname', 'remark1', 'ciheats', 'diheats'],
    ProductionRegisterHeatTypewise: ['furnacetonnage', 'entryno', 'flag', 'trdate', 'subachead', 'itcode', 'ActualQty', 'ActualWeight', 'empname', 'remark1', 'ciheats', 'diheats'],
    RejectionWiseProductionReport: [],
  };

  const generateTableHeaders = (fields) => {
    return fields.map((field) => (
      <th
        key={field}
        style={{
          padding: '5px',
          background: '#f2f2f2',
          border: '1px solid #333',
        }}
      >
        {getCustomFieldName(field) || ''}
      </th>
    ));
  };

  const fieldMappings = [
    { original: 'furnacetonnage', custom: 'FurnaceTonnage' },
    { original: 'entryno', custom: 'EntryNo' },
    { original: 'MonthNo', custom: 'Month' },
    { original: 'flag', custom: 'Flag' },
    { original: 'entryno', custom: 'EntryNo' },
    { original: 'trdate', custom: 'TrDate' },
    { original: 'trdate', custom: 'TrDate' },
    { original: 'empname', custom: 'EmpName' },
    { original: 'ciheats', custom: 'CIHeats' },
    { original: 'diheats', custom: 'DIHeats' },
    { original: 'subachead', custom: 'PartyName' },
    { original: 'subAcHead', custom: 'PartyName' },
    { original: 'SubAcHead', custom: 'PartyName' },
    { original: 'itcode', custom: 'ItemName' },
    (endpoint === 'ProductionRegisterHeatTypewise' || endpoint === 'ProductionRegisterHourwise')
      ? { original: 'Remark1', custom: 'Narration' }
      : { original: 'Remark1', custom: 'MachiningYN' },
  ];

  const getCustomFieldName = (originalField) => {
    const mapping = fieldMappings.find(mapping => mapping.original.toLowerCase() === originalField.toLowerCase());
    return mapping ? mapping.custom : originalField;
  };

  const generateTableRows = (rowData, fields) => {
    return fields.map((key, colIndex) => {
      let value;
      if (endpoint === 'ProductionRegisterMonthwise' && (key === 'Qty-Weight')) {
        value = `${rowData['ProdQty']} - ${rowData['ProdWeight']}`;
      } else {
        value = key.toLowerCase().includes('date') && rowData[key]
          ? (() => {
            const date = new Date(rowData[key]);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
          })()
          : key === 'SubAccode' || key === 'subaccode' ? getSubAcHead(rowData[key])
            : key === 'MonthNo' ? getMonthName(rowData[key])
              : key === 'ItCode' || key === 'Itcode' || key === 'itcode' ? (
                <span>
                  {getItInfo(rowData[key]).ItName} - {getItInfo(rowData[key]).PartNo}
                </span>
              )
                : key === 'Amount' ? (
                  (() => {
                    const cirate = Math.abs(rowData['CIRate'] || 0);
                    const dirate = Math.abs(rowData['DIRate'] || 0);
                    const prodweight = Math.abs(rowData['ProdWeight'] || 0);
                    const itcode = rowData['itcode'];
                    const item = itemMasterEntries.find(group => group.ItCode === itcode);
                    const rate = item ? item.GradeCode : 0;

                    const stockBal = rate === '1' ? cirate * prodweight : rate === '2' ? dirate * prodweight : 0;
                    return stockBal.toFixed(2);
                  })()
                )
                  : key === 'NatureCode' ? getNatureName(rowData[key])
                    : key === 'VehicleCode' ? getVehicleName(rowData[key])
                      : key === 'RejCode' ? getRejName(rowData[key])
                        : key === 'ProcessCode' ? getProcessName(rowData[key])
                          : renderNumericCell(rowData[key]);
      }
      const isNumeric = !isNaN(parseFloat(value)) && isFinite(value);
      const formattedValue = isNumeric && key !== 'EntryNo' && (key !== 'ItCode' || key !== 'ITCODE') ? parseFloat(value).toFixed(2) : value;

      return (
        <td key={colIndex} style={{ padding: '4px', border: '1px solid #333', textAlign: isNumeric ? 'right' : 'left' }}>
          {formattedValue}
        </td>
      );
    });
  };

  const renderNumericCell = (value) => {
    if (typeof value === 'number') {
      return Math.abs(Math.round(value * 100) / 100);
    }
    return value;
  };

  const groupDataByFlag = (data) => {
    const groupedData = {};
    //console.log("groupDataByEntry", data);
    data.forEach((item) => {
      if (!groupedData[item.entryno]) {
        groupedData[item.entryno] = [];
      }
      groupedData[item.entryno].push(item);
    });
    return groupedData;
  };

  const groupedReportData = groupDataByFlag(reportData);

  

  return (
    <div>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '72vh', color: 'white' }}>
          <CircularProgress style={{ color: '#2196f3' }} />
        </div>
      ) : (
        <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
          <Stack direction="row" spacing={1} marginBottom={.5}>
            <TextField
              type="date"
              label="Start Date"
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              type="date"
              label="End Date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />

            {selectSubledger && (
              <FormControl>
                <InputLabel id="subledgerCodeLabel">Select Party</InputLabel>
                <Select
                  labelId="subledgerCodeLabel"
                  label="Select Party"
                  value={subledgerCode}
                  onChange={handleSubLedgerChange}
                  style={{ minWidth: '200px' }}
                >
                  {subledgerMaster.map((group) => (
                    <MenuItem key={group.SubAcCode} value={group.SubAcCode}>
                      {group.SubAcHead}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {selectItem && (
              <FormControl>
                <InputLabel id="itemCodeLabel">Select ItemName</InputLabel>
                <Select
                  labelId="itemCodeLabel"
                  label="Select ItemName"
                  value={itemCode}
                  onChange={handleItemChange}
                  style={{ minWidth: '200px' }}
                >
                  {itemMasterEntries.map((group) => (
                    <MenuItem key={group.ItCode} value={group.ItCode}>
                      {group.ItName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {selectHours && (<TextField
              type="number"
              label="Hours"
              id="hours"
              value={Hours}
              onChange={(e) => setHours(e.target.value)}
              style={{ width: '80px', marginRight: '5px' }} // Adjust the styling as needed
            />)}

            {selectFurnaceTonnage && (<TextField
              type="number"
              label="FurnaceTonnage"
              id="furnaceTonnage"
              value={FurnaceTonnage}
              onChange={(e) => setFurnaceTonnage(e.target.value)}
              style={{ width: '80px', marginRight: '5px' }} // Adjust the styling as needed
            />)}

            {selectGrade && (<TextField
              type="text"
              label="Grade"
              id="grade"
              value={grade}
              onChange={(e) => setGrade(e.target.value)}
              style={{ width: '70px', marginRight: '10px' }} // Adjust the styling as needed
            />)}
            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "yellow", color: "black", marginBottom: "4px", float: 'right', marginRight: "12px", '&:hover': {
                  color: 'white',
                },
              }}
              onClick={handleSetParams}
            >
              View Report
            </Button>
            <Button variant="contained" color="secondary" onClick={handleReset}>
              Reset
            </Button>
          </Stack>

          {showGrid && (
            <Grid item>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px',marginTop:'10px' }}>
                <h1 style={{ fontSize: '20px', marginTop: '0', marginBottom: '0' }}>
                  {(endpoint === 'ProductionRegisterItemwise')
                    ? 'Production Register Itemwise'
                    : (endpoint === 'ProductionRegisterHeatTypewise')
                      ? 'Production Register HeatTypewise'
                      : (endpoint === 'ProductionRegisterHourwise')
                        ? 'Production Register Hourwise' : endpoint}
                </h1>
                <div>
                  <Button
                    variant="contained"
                    onClick={() => setShowH1Component(true)}
                    sx={{ backgroundColor: 'red', color: 'white', marginLeft: '10px', '&:hover': { color: 'white' } }}
                    startIcon={<DownloadIcon />}
                  >
                    Download PDF
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => handleExport('csv')}
                    sx={{ backgroundColor: 'yellow', color: 'black', marginLeft: '10px', '&:hover': { color: 'white' } }}
                    startIcon={<CsvIcon />}
                  >
                    Export as CSV
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => handleExport('excel')}
                    sx={{ backgroundColor: 'green', color: 'white', marginLeft: '10px', '&:hover': { color: 'white' } }}
                    startIcon={<ExcelIcon />}
                  >
                    Export as Excel
                  </Button>
                </div>
              </div>
            </Grid>
          )}


          {showGrid && ((reportData && reportData.length > 0) || (reportData1 && reportData1.length > 0)) && (
            <div ref={componentPDF} style={{ width: '100%' }}>
              {showH1Component && (<h3>
                <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                  <div style={{ fontSize: '18px' }}>{getCompanyName(props.selectedCompany)}</div>
                  <div style={{ fontSize: '14px' }}>Date :- From&nbsp;{`${startDate} to ${endDate}`}</div>
                  {subledgerCode && <div style={{ fontSize: '14px' }}>Ledger A/c: {getSubAcHead(subledgerCode)} </div>}
                  {itemCode && <div style={{ fontSize: '14px' }}>Item Name: {getItName(itemCode)} </div>}

                  <h1 style={{ fontSize: '18px', marginTop: '0' }}>
                    {(endpoint === 'ProductionRegisterItemwise')
                      ? 'Production Register Itemwise'
                      : (endpoint === 'ProductionRegisterHeatTypewise')
                        ? 'Production Register HeatTypewise'
                        : (endpoint === 'ProductionRegisterHourwise')
                          ? 'Production Register Hourwise' : endpoint}
                  </h1>
                </div>
              </h3>)}
              <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #333' }}>
                <thead>
                  <tr style={{ background: '#f2f2f2', color: 'black' }}>
                    <th style={{ padding: '5px', background: '#f2f2f2', border: '1px solid #333', }}>Sr.No.</th>
                    {generateTableHeaders(endpointFields[endpoint])}
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(groupedReportData).map(([flag, data], groupIndex) => (
                    <React.Fragment key={flag}>
                      {groupIndex > 0 && generateCalculationRow(groupedReportData[Object.keys(groupedReportData)[groupIndex - 1]])}
                      {data.map((rowData, index) => (
                        <tr key={index} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                          <td style={{ padding: '4px', border: '1px solid #333' }}>{serialNumber + index}</td>
                          {generateTableRows(rowData, endpointFields[endpoint])}
                        </tr>
                      ))}
                      {groupIndex === Object.keys(groupedReportData).length - 1 && generateCalculationRow(data)}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        </div>)}
    </div>
  );
}
export default ProdReport;















